import { render, staticRenderFns } from "./newSlug.vue?vue&type=template&id=d7126c50&"
import script from "./newSlug.vue?vue&type=script&lang=js&"
export * from "./newSlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports